// extracted by mini-css-extract-plugin
module.exports = {"powered_container":"poweredByTokko_powered_container__QbTN2","imgContainer":"poweredByTokko_imgContainer__H9B0Q","opennaventImg":"poweredByTokko_opennaventImg__nnL21"};